import { ACTION_TYPE, getActionTypes } from "Store/Shared/Actions/Helpers";
import ACTIONS from "./ActionTypes";

export const fetchContactModules = (id: any): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.FETCH_ALL_CONTACT_MODULES),
    callAPI: {
        url: `/api/v2/contact_module/entity/${id}`
    }
});

export const patchContactModules = (id: any, data: any): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.PATCH_CONTACT_MODULE),
    callAPI: {
        method: 'PATCH',
        url: `/api/v2/contact_module/${id}`,
        body: data
    }
})

export const createContactModule = (id: any, data: any): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.CREATE_CONTACT_MODULE),
    callAPI: {
        method: 'POST',
        url: `/api/v2/contact_module/entity/${id}`,
        body: data
    }
}) 

export const deleteContactModule = (id: any): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.DELETE_CONTACT_MODULE),
    callAPI: {
        method: 'DELETE',
        url: `/api/v2/contact_module/${id}`,
    }
})